<template>
	<v-dialog width="600px" persistent v-model="model" fullscreen hide-overlay>
		<v-card>
			<v-card-text class="pa-4">
				<v-layout class="justify-space-between mb-2">
					<h5 class="title indigo-text text--darken-4">
						Create/Reset mPIN
					</h5>
					<v-btn
						fab
						flat
						class="top-right-align"
						@click="closeModal()"
					>
						<v-icon>close</v-icon>
					</v-btn>
				</v-layout>
				<v-layout row wrap class="mb-4">
					<v-flex xs12 md6 lg3>
						<v-text-field
							v-model="otp"
							label="OTP*"
							type="number"
							placeholder="Enter Otp"
							class="text-field-wrapper ma-0 pt-4"
						/>
					</v-flex>
				</v-layout>
				<v-layout>
					<v-flex xs12 md6 lg3 class="mb-4">
						<v-text-field
							v-model="mPin"
							label="Enter MPIN (4-digits)*"
							type="password"
							placeholder="* * * *"
							class="text-field-wrapper ma-0 pt-4"
							filled
						/>
					</v-flex>
				</v-layout>
				<v-layout class="mb-2">
					<v-flex xs12 md6 lg3>
						<v-text-field
							v-model="confirmMPIN"
							label="Confirm MPIN*"
							type="password"
							placeholder="* * * *"
							class="text-field-wrapper ma-0 pt-4"
							outlined
							:rules="[checkPasswordMatching]"
						/>
					</v-flex>
				</v-layout>
				<v-layout>
					<v-flex xs12 md6 lg3 class="d-flex mt-4">
						<v-btn
							class="white--text ma-0 py-4 btn"
							:loading="generatingMpin"
							:color="themeInputColor"
							@click="generateMPIN"
							:disabled="checkDisabled"
							>Create MPIN</v-btn
						>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { GENERATE_MPIN, GENERATE_MPIN_OTP } from "@/store/action-types";
export default {
	name: "GenerateMPIN",
	props: ["model", "themeInputColor"],
	data() {
		return {
			otp: null,
			mPin: null,
			confirmMPIN: null,
			generatingMpin: false
		};
	},
	mounted() {
		this.$store.dispatch(GENERATE_MPIN_OTP.dispatch);
	},
	computed: {
		checkPasswordMatching() {
			if (this.mPin && this.confirmMPIN === this.mPin) {
				return true;
			}
			return "mPin do not match.";
		},
		checkDisabled() {
			return (
				!this.otp ||
				!this.mPin ||
				!this.confirmMPIN ||
				this.mPin != this.confirmMPIN
			);
		}
	},
	methods: {
		closeModal() {
			this.$emit("CLOSE_MODAL", this.model);
		},
		generateMPIN() {
			if (!this.generatingMpin) {
				this.generatingMpin = true;
				this.$store
					.dispatch(GENERATE_MPIN.dispatch, {
						otp: this.otp,
						mPin: this.mPin
					})
					.then(() => {
						this.closeModal();
					})
					.finally(() => {
						this.generatingMpin = false;
					});
			}
		}
	}
};
</script>
